import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

export const FluidWrapper = styled.main`
  overflow: hidden;

  ${mediaMin.sm`
    padding: 0;
  `}

  ${mediaMin.xlg`
    padding: 0;
  `}
`;

export const Wrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  color: ${({ theme }) => theme.palette.white};
`;

export const HeroText = styled.div`
  padding: 160px 16px 0;
  text-align: center;
`;

export const HeroImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 auto;
  padding: 64px 24px 0;
  width: 100%;
  max-width: 400px;

  ${mediaMin.xs`
    max-width: 500px;
    width: calc(100% - 160px);
  `}

  ${mediaMin.sm`
    max-width: 800px;
    width: calc(100% - 160px);
  `}

  ${mediaMin.md`
    max-width: 1200px;
    width: calc(100% - 160px);

    &:before {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(
        180deg,
        rgba(24, 24, 24, 0) 50%,
        rgba(24, 24, 24, 1) 100%
      );
    }
  `}
`;

export const HeroImage = styled.img`
  width: 100%;
`;
